import { render, staticRenderFns } from "./DuplicatesDetail.vue?vue&type=template&id=fc36f64e&scoped=true&"
import script from "./DuplicatesDetail.vue?vue&type=script&lang=js&"
export * from "./DuplicatesDetail.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatesDetail.vue?vue&type=style&index=0&id=fc36f64e&scoped=true&lang=scss&"
import style1 from "./DuplicatesDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc36f64e",
  null
  
)

export default component.exports